import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import { getQueryString, checkPhone } from "../../util";
import { ClickType } from "../const";
import Utils from "src/lib/utils/Utils";
import { getMessageCode, drawDownload } from "../../service";
import { Toast } from "antd-mobile";
import "./index.scss";

interface IProps {
    roleId: string;
    clickBtn: string;
    userType: string;
    onClose: () => void;
    onOpenDraw: () => void;
    onOpenInviteDownLoad: () => void;
    updateUserDownLoadInfo: (hasDownLoad: boolean, hasInviteDownLoad: boolean) => void;
    changeMyCode: (myCode: string) => void;
}

interface IState {
    inviteCode: string;
    phone: string;
    code: string;
    // 获取邀请码返回值，后续登录使用
    checkcode: number;
    orderid: number;
    time: number;
    loading: boolean;
}

// 手机号验证弹窗
class CheckModal extends BaseComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            inviteCode: getQueryString("code") || "",
            phone: "",
            code: "",
            checkcode: 0,
            orderid: 0,
            time: 0,
            loading: false,
        };
    }

    /**修改手机号 */
    onChangePhone = (e: any) => {
        let phone = e.target.value;
        this.setState({
            phone,
        });
    };

    /**修改验证码 */
    onChangeCode = (e: any) => {
        let code = e.target.value;
        this.setState({
            code,
        });
    };

    /**修改邀请码 */
    onChangeInviteCode = (e: any) => {
        let inviteCode = e.target.value;
        this.setState({
            inviteCode,
        });
    };

    /**修改倒计时 */
    onChangeTime = (time: number) => {
        this.setState({
            time,
        });
    };

    /**获取验证码*/
    onGetCode = () => {
        const { roleId } = this.props;
        const { time, phone } = this.state;
        if (time) return;
        // if (!(window as any).canuseCookie) {
        //     Toast.show("如需验证，请允许浏览器使用cookie", 3, true);
        //     return;
        // }
        if (!phone) {
            Toast.show("请输入手机号", 3, true);
            return;
        }
        if (!checkPhone(phone)) {
            Toast.show("请输入正确的11位手机号", 3, true);
            return;
        }
        Utils.correctCountDownFactory({
            ms: 60 * 1000,
            log: false,
            immediately: true,
            cb: (restTime) => {
                const time = restTime > 0 ? restTime / 1000 : 0;
                this.onChangeTime(time);
            },
        });
        getMessageCode({ p: phone, roleId }).then((res) => {
            const { code, rev, data } = res;
            const { checkcode, orderid } = data || {};
            if (code == 0 && rev == true) {
                Toast.show("验证码发送成功，请注意查收", 3, true);
                this.setState({
                    checkcode,
                    orderid,
                });
                return;
            }
            Toast.show("验证码发送失败，请重试", 3, true);
            this.setState({
                checkcode: 0,
                orderid: 0,
            });
        });
    };

    /**
     * 点击确定领取皮肤
     */
    onCheck = () => {
        const { clickBtn, roleId, changeMyCode, updateUserDownLoadInfo, onOpenDraw, onClose, onOpenInviteDownLoad } = this.props;
        const { phone, code, checkcode, orderid, loading, inviteCode } = this.state;
        if (!(window as any).canuseCookie) {
            Toast.show("如需验证，请允许浏览器使用cookie", 3, true);
            return;
        }
        if (!phone) {
            Toast.show("请输入手机号", 3, true);
            return;
        }
        if (!checkPhone(phone)) {
            Toast.show("请输入正确的11位手机号", 3, true);
            return;
        }
        if (!code) {
            Toast.show("请输入验证码", 3, true);
            return;
        }
        if (!checkcode || !orderid) {
            Toast.show("验证码输入错误", 3, true);
            return;
        }
        if (loading) return;
        this.setState({
            loading: true,
        });
        drawDownload({ p: phone, roleId, checkcode, orderid, verifycode: code, code: inviteCode }).then((res: any) => {
            this.setState({
                loading: false,
            });
            const { code, rev, msg, data } = res || {};
            const { votes, invite, votesDown, inviteDown, phone, icode, isPhone, isRegValid } = data;
            // 领取成功
            if (code === 0 && rev == true) {
                updateUserDownLoadInfo(true, false);
                changeMyCode(icode || "");
                // 邀请人不可领取
                if (isRegValid === 0) {
                    Toast.show("您并非接受邀请后新注册创角的用户，无法成功帮助好友完成任务", 3, true);
                }
                // 打开邀请
                if (clickBtn === ClickType.XX) {
                    onOpenInviteDownLoad();
                    onClose();
                }
                // 打开领取成功
                else {
                    onOpenDraw();
                    onClose();
                }
            }
            // 领取失败
            else {
                if (code === 402) {
                    const hasDownLoad = votes !== 0 || votesDown !== 0;
                    const hasInviteDownLoad = invite !== 0 || inviteDown !== 0;
                    // 手机号已被使用
                    if (isPhone === 0 && phone !== 0) {
                        Toast.show("手机号已被使用", 3, true);
                        return;
                    }
                    // 已领取下载奖励
                    if (hasDownLoad) {
                        const text = votes !== 0 ? "您已通过预约活动领取过皮肤" : "此账号下已有角色领取皮肤";
                        Toast.show(text, 3, true);
                        updateUserDownLoadInfo(true, hasInviteDownLoad);
                        changeMyCode(icode || "");
                        // 打开邀请
                        if (clickBtn === ClickType.XX) {
                            onOpenInviteDownLoad();
                            onClose();
                        } else {
                            onClose();
                        }
                        return;
                    }
                    Toast.show(msg || "领取失败", 3, true);
                } else {
                    Toast.show(msg || "领取失败", 3, true);
                }
            }
        });
    };

    render() {
        const { userType = "", onClose } = this.props;
        const { phone, code, inviteCode, time } = this.state;

        return (
            <div className="check-modal">
                <div className={`check-content ${userType}`}>
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="form">
                        <div className="input-phone">
                            <input
                                type="text"
                                maxLength={11}
                                autoComplete="off"
                                placeholder="请输入手机号"
                                value={phone}
                                onChange={(e) => this.onChangePhone(e)}
                            />
                        </div>
                        <div className="test-box">
                            <div className="input-test">
                                <input
                                    type="text"
                                    maxLength={4}
                                    autoComplete="off"
                                    placeholder="请输入验证码"
                                    value={code}
                                    onChange={(e) => this.onChangeCode(e)}
                                />
                            </div>
                            <div className={time > 0 ? "get-code disable" : "get-code"} onClick={this.onGetCode}>
                                {time > 0 ? time : "获取验证码"}
                            </div>
                        </div>
                        <div className="input-invite">
                            <div className="invite-title">邀请码</div>
                            <input
                                type="text"
                                maxLength={11}
                                autoComplete="off"
                                placeholder="若没有可不填写"
                                value={inviteCode}
                                onChange={(e) => this.onChangeInviteCode(e)}
                            />
                        </div>
                        <div className="invite-text">*请填写6位数字邀请码或邀请人手机号</div>
                        <div className="btn-submit" onClick={this.onCheck}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CheckModal;
